// Theme configuration matching Flutter colors

export const colors = {
  // Primary Blue
  bluePrimary: {
    100: '#E9ECF4',
    200: '#D4DAEA',
    300: '#93A3CB',
    400: '#496DAF',
    500: '#1B489B',
    600: '#4C55D7',
    700: '#9097FF',
    800: '#7176BE',
    900: '#425FF0',
    DEFAULT: '#1B489B',
  },
  // Secondary Blue
  blueSecondary: {
    100: '#E7E7E9',
    200: '#CECFD3',
    300: '#858791',
    400: '#3D3F50',
    500: '#0C0F24',
    600: '#000000',
    700: '#153A83',
    800: '#1A237E',
    900: '#1B1B36',
    DEFAULT: '#0C0F24',
  },
  // Warning
  warning: {
    100: '#FFE1A4',
    200: '#895D0B',
    300: '#721c24',
    400: '#CA0606',
    DEFAULT: '#895D0B',
  },
  warningSecondary: {
    100: '#FFF9E6',
    200: '#FFE8B7',
    300: '#FFE1A4',
    400: '#FFD54F',
    500: '#FBC02D',
    600: '#F9A825',
    700: '#F57F20',
    800: '#F79009',
    DEFAULT: '#FBC02D',
  },
  // Success
  success: {
    100: '#CCF2DB',
    200: '#1E774A',
    300: '#0a454e',
    400: '#00BC22',
    500: '#16A249',
    600: '#DCFAE6',
    700: '#ABEFC6',
    800: '#75E0A7',
    DEFAULT: '#1E774A',
  },
  // Danger
  danger: {
    100: '#fef7f8',
    200: '#f7d3d6',
    300: '#f1aeb5',
    400: '#eb8a93',
    500: '#e46572',
    600: '#de4150',
    700: '#c22f3d',
    800: '#9a2530',
    900: '#721c24',
    1000: '#4b1217',
    DEFAULT: '#dc3545',
  },
  // Gray
  gray: {
    100: '#fafafa',
    200: '#f2f2f2',
    300: '#e6e6e6',
    400: '#dadada',
    500: '#cccccc',
    600: '#999999',
    700: '#808080',
    800: '#4d4d4d',
    900: '#303030',
    1000: '#202020',
    DEFAULT: '#e6e6e6',
  },
  // Sky
  sky: {
    100: '#f2f8fd',
    200: '#d9eafa',
    300: '#c0ddf6',
    400: '#8dc1ef',
    500: '#54a2e7',
    600: '#1a83df',
    700: '#0166c0',
    800: '#014c8e',
    900: '#00325d',
    1000: '#00172c',
    DEFAULT: '#0175DB',
  },
  // Purple
  purple: {
    100: '#ECE6F9',
    200: '#CDB7F5',
    300: '#C1A7F8',
    400: '#827AEA',
    500: '#7C3BED',
    600: '#7976EA',
    DEFAULT: '#884DEE',
  },
  // Custom Black
  customBlack: {
    100: '#C4C4C4',
    200: '#717171',
    300: '#71717A',
    400: '#676F7E',
    DEFAULT: '#292929',
  },
  // Error
  error: {
    0: '#FFFBFA',
    1: '#FEF3F2',
    2: '#FEE4E2',
    3: '#FECDCA',
    4: '#FDA29B',
    5: '#F97066',
    6: '#F04438',
    7: '#D92D20',
    8: '#B42318',
    9: '#912018',
    10: '#7A271A',
    11: '#55160C',
    DEFAULT: '#F04438',
  },
  // Blue Mid
  blueMid: {
    1: '#EFF6FF',
    2: '#E2E8F0',
    5: '#3B82F6',
    6: '#2563EB',
    9: '#9CA3AF',
    10: '#64748B',
    11: '#4B5563',
    DEFAULT: '#1D4ED8',
  },
  // White shades
  white: {
    100: '#FAFAFB',
    200: '#F9F9FA',
    300: '#F4F4F5',
    400: '#F9FAFB',
    500: '#F5F5FC',
    600: '#DADFE7',
    DEFAULT: '#FFFFFF',
  },
  // Disable
  disable: {
    100: '#E2E3E4',
    200: '#D5D6D7',
    300: '#C2C3C4',
    400: '#A2A3A4',
    500: '#58595B',
    600: '#6E6F70',
    700: '#58595B',
    800: '#464748',
    900: '#363738',
    DEFAULT: '#58595B',
  },
  // Base colors
  black: '#000000',
  transparent: 'transparent',
} as const;
